import {
  Typography,
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'
import ExpandMoreIcon from 'mdi-react/ExpandMoreIcon'
import { useState, Fragment, ChangeEvent, CSSProperties } from 'react'

// const useStyles = makeStyles({
//   termsFrame: {
//     width: '100%',
//     height: '100%',
//     border: 'none',
//     'box-sizing': 'border-box'
//   }
// })

const CustomAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(Accordion)

const CustomAccordionTitle = withStyles({
  root: {
    backgroundColor: '#E7ECEF',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(AccordionSummary)

const CustomAccordionContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(AccordionDetails)

export interface CustomExpansionPanelContent {
  title: string
  Content: JSX.Element
  badge?: string
}

const badgeStyle: CSSProperties = {
  marginLeft: 8,
  backgroundColor: '#4f9b44',
  color: '#fff',
  fontSize: '0.7rem',
  fontWeight: 600,
  lineHeight: 1.6,
  padding: '1px 8px',
  borderRadius: 10,
  verticalAlign: 'middle'
}

interface CustomExpansionPanelProps extends CustomExpansionPanelContent {
  expandedPanel: string
  key: string
  handleChange: (
    panel: string
  ) => (
    event: ChangeEvent<Record<string, unknown>>,
    newExpanded: boolean
  ) => void
}

const CustomExpansionPanel = ({
  expandedPanel,
  title,
  Content,
  badge,
  handleChange
}: CustomExpansionPanelProps) => {
  return (
    <CustomAccordion
      square
      expanded={expandedPanel === title}
      onChange={handleChange(title)}
    >
      <CustomAccordionTitle expandIcon={<ExpandMoreIcon />}>
        <Typography>
          {title}
          {badge && <span style={badgeStyle}>{badge}</span>}
        </Typography>
      </CustomAccordionTitle>
      <CustomAccordionContent>{Content}</CustomAccordionContent>
    </CustomAccordion>
  )
}

interface CustomExpansionPanelListProps {
  ExpansionPanelListData: CustomExpansionPanelContent[]
}

const CustomExpansionPanelList = ({
  ExpansionPanelListData
}: CustomExpansionPanelListProps): JSX.Element => {
  const [expandedPanel, togglePanel] = useState<string>('none')
  const handleChange = (panel: string) => (
    event: ChangeEvent<Record<string, unknown>>,
    newExpanded: boolean
  ) => {
    togglePanel(newExpanded ? panel : 'none')
  }
  // const classes = useStyles()

  // const getTermsDate = useCallback((apartmentDate: number | undefined) => {
  //   const termsVersions = process.env.REACT_APP_TERMS_VERSIONS?.split(',') || []
  //   if (!termsVersions.length) {
  //     return ''
  //   }
  //   if (apartmentDate === undefined)
  //     return termsVersions[termsVersions.length - 1]
  //   for (const item of termsVersions.reverse()) {
  //     const date = moment(item, 'YYYYMMDD')
  //     if (date.isValid() && apartmentDate > date.valueOf()) {
  //       return item
  //     }
  //   }
  //   return termsVersions[0]
  // }, [])

  // const getTermsLink = useCallback(
  //   (apartmentDate: number | undefined) => {
  //     const frameLink = process.env.REACT_APP_TERMS_URL_TEMPLATE || ''
  //     return frameLink
  //       .replace('{language}', i18n.language)
  //       .replace('{version}', getTermsDate(apartmentDate).toString())
  //   },
  //   [getTermsDate]
  // )
  return (
    <Fragment>
      {ExpansionPanelListData.map(({ title, Content, badge }) => (
        <CustomExpansionPanel
          key={title}
          title={title}
          Content={Content}
          badge={badge}
          expandedPanel={expandedPanel}
          handleChange={handleChange}
        />
      ))}
      {/* <CustomExpansionPanel
        key={i18n.t('application.phone.title')}
        title={i18n.t('application.phone.title')}
        Content={
          <iframe
            title='terms'
            className={classes.termsFrame}
            src={getTermsLink(new Date().getTime())}
          />
        }
        expandedPanel={expandedPanel}
        handleChange={handleChange}
      /> */}
    </Fragment>
  )
}

export default CustomExpansionPanelList
